import { render, staticRenderFns } from "./SelectRuoliClassic.vue?vue&type=template&id=ad3dee6e&scoped=true&"
import script from "./SelectRuoliClassic.vue?vue&type=script&lang=js&"
export * from "./SelectRuoliClassic.vue?vue&type=script&lang=js&"
import style0 from "./SelectRuoliClassic.vue?vue&type=style&index=0&id=ad3dee6e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ad3dee6e",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/Users/diego/Desktop/code/asta-live/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ad3dee6e')) {
      api.createRecord('ad3dee6e', component.options)
    } else {
      api.reload('ad3dee6e', component.options)
    }
    module.hot.accept("./SelectRuoliClassic.vue?vue&type=template&id=ad3dee6e&scoped=true&", function () {
      api.rerender('ad3dee6e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/common/SelectRuoliClassic.vue"
export default component.exports